module.exports = __webpack_public_path__ + "images/emoji/sob.8a14abd72eb46557e7b4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sob.png
// module id = gsKa
// module chunks = 13